module.exports = __webpack_public_path__ + "c2dd1c5cfd057d3100244d6f5e59a4a4.png";